// Site-wide mock data for 時光逆行駭客

export const navItems = [
  { label: "首頁", path: "/" },
  { label: "關於時光逆行駭客", path: "/about" },
  { label: "核心價值", path: "/core-value" },
  {
    label: "逆齡路線方案",
    path: "/protocol",
    children: [{ label: "時光逆行四部曲", path: "/protocol" }],
  },
  { label: "醫美儀器介紹", path: "/equipment" },
  {
    label: "客戶見證",
    path: "/testimonials",
    children: [{ label: "真實故事", path: "/stories" }],
  },
  {
    label: "逆齡知識庫",
    path: "/knowledge",
    children: [
      { label: "您是哪一種正在變老的型態？", path: "/aging-types" },
      { label: "專欄文章", path: "/articles" },
    ],
  },
  { label: "活動講座 / 企業合作", path: "/events" },
  { label: "線上預約", path: "/booking" },
];

export const footerNav = {
  about: [
    { label: "品牌故事", path: "/about" },
    { label: "院長介紹", path: "/about" },
    { label: "核心理念", path: "/core-value" },
  ],
  services: [
    { label: "時光逆行四部曲", path: "/protocol" },
    { label: "醫美儀器介紹", path: "/equipment" },
    { label: "線上預約", path: "/booking" },
  ],
  resources: [
    { label: "逆齡知識庫", path: "/knowledge" },
    { label: "老化類型分析", path: "/aging-types" },
    { label: "專欄文章", path: "/articles" },
    { label: "活動講座", path: "/events" },
  ],
};

export const lineUrl = "https://lin.ee/5ogqPSQ";
export const lineId = "@404wdnql";

export const legalDisclaimer =
  "本網站內容僅供一般醫學美容、健康管理與衛教參考，實際療程、醫療處置與個人建議，仍需由合格醫師依個人狀況進行專業評估。任何療程皆有其風險與限制，網站內容不代表療效保證。";

/* ─── Hero ─── */
export const heroData = {
  tagline: "青春痘 × 醫美 × 功能醫學 × 逆齡駭客",
  titleLine1: "你的變老，我來駭入",
  titleLine2: "時光逆行駭客｜曾驛翔院長",
  subtitle:
    "皮膚科出身、專研醫學美容與功能性醫療，結合體檢數據、AI 評估與醫美儀器，為青春期到更年期、長青族設計專屬的「逆齡路線圖」。",
  ctaLine: "加入 LINE 諮詢",
  ctaBooking: "預約逆齡評估",
  scrollHint: "SCROLL TO EXPLORE",
};

/* ─── Brand Position ─── */
export const brandPositionData = {
  title: "不是讓時間倒轉，而是找出你為什麼老得那麼快",
  description:
    "「時光逆行駭客」不是承諾凍齡，也不是單純推銷療程，而是像駭客讀懂程式碼一樣，從膚況、體態、睡眠、壓力、代謝、體檢數據與生活節奏中，找出老化速度變快的關鍵節點。",
};

/* ─── Four Service Groups ─── */
export const serviceGroups = [
  {
    id: "acne",
    icon: "ri-sparkling-line",
    title: "青春痘與痘疤族群",
    items: ["青春痘", "粉刺", "痘疤", "毛孔", "出油", "膚況不穩"],
    accent: "#4BC0FF",
  },
  {
    id: "aesthetic",
    icon: "ri-refresh-line",
    title: "醫美與外觀老化族群",
    items: ["斑點", "暗沉", "鬆弛", "細紋", "臉部輪廓下滑"],
    accent: "#FACC6B",
  },
  {
    id: "male-aging",
    icon: "ri-men-line",
    title: "男性懸崖式衰老族群",
    items: ["肚子變大", "體力下降", "精神疲勞", "壓力與代謝問題"],
    accent: "#22D3EE",
  },
  {
    id: "senior",
    icon: "ri-heart-pulse-line",
    title: "熟齡與長青族群",
    items: ["慢老照護", "體力維持", "行動力", "生活品質與長期健康管理"],
    accent: "#35E0B9",
  },
];

/* ─── Reverse Aging Concept ─── */
export const reverseAgingConcept = {
  title: "先評估，再設計，不是一張療程價目表",
  description:
    "每個人的老化路徑都不同。我們透過完整的逆齡評估，讀懂你身體的「程式碼」，再設計專屬的逆齡路線圖。",
  evaluations: [
    {
      label: "男性懸崖式衰老評估",
      desc: "檢視代謝、壓力荷爾蒙、體態變化與生活節奏，找出男性 30+ 後衰老加速的真正原因。",
    },
    {
      label: "膚況與外觀老化評估",
      desc: "從膠原流失、肌膚結構、色素沉澱到輪廓變化，全面掃描臉部老化進程。",
    },
    {
      label: "熟齡與長青慢老評估",
      desc: "結合功能性醫學檢測與生活品質量表，為熟齡族設計維持體能與活力的長期方案。",
    },
  ],
};

/* ─── Core Values Preview (homepage) ─── */
export const coreValuesPreview = [
  {
    icon: "ri-bug-line",
    title: "老化程式除錯，而不是凍齡魔術",
    description:
      "老化不是魔法，而是生物程式。我們像駭客讀懂程式碼一樣，找出導致你老得比別人快的關鍵節點，精準除錯。",
  },
  {
    icon: "ri-dashboard-3-line",
    title: "懶人也能做到的逆齡系統",
    description:
      "不需要每天花兩小時保養。我們設計的是可持續、可執行、可追蹤的逆齡系統，讓忙碌的你也能輕鬆維持。",
  },
  {
    icon: "ri-user-smile-line",
    title: "尊重每個年齡的樣子，不盲目追求同一種美",
    description:
      "30 歲有 30 歲的光采，50 歲有 50 歲的韻味。我們不複製同一張臉，而是讓每個年齡的你，都活成最好的自己。",
  },
];

/* ─── Aging Types Knowledge Hub (homepage) ─── */
export const agingTypesHub = {
  title: "你是哪一種正在變老的型態？",
  description: "老化有百百種路徑。先認識自己的老化型態，才能對症設計逆齡方案。",
  types: [
    { label: "男性懸崖式衰老型", icon: "ri-men-line", path: "/aging-types" },
    { label: "過勞上班族型", icon: "ri-briefcase-line", path: "/aging-types" },
    { label: "鏡子前嘆氣的美肌控", icon: "ri-emotion-unhappy-line", path: "/aging-types" },
    { label: "功能下滑熟齡型", icon: "ri-heart-pulse-line", path: "/aging-types" },
    { label: "小心維持的長青族", icon: "ri-shield-check-line", path: "/aging-types" },
  ],
};

/* ─── Testimonials Preview ─── */
export const testimonialsPreview = {
  sectionLabel: "// CLIENT TESTIMONY",
  complianceNote:
    "以下為個人主觀感受分享，不代表所有人皆有相同結果，實際狀況仍需由醫師評估。",
  quote: [
    "我以為老化是不可逆的命運，",
    "直到遇見曾院長，",
    "才發現原來這是一段可以重寫的程式。",
  ],
  author: "林小姐，42歲",
  rating: 5,
  badge: "逆齡指數提升 +37%",
};

/* ─── Final CTA ─── */
export const finalCtaData = {
  label: "// INITIATE BOOKING SEQUENCE",
  title: "你的逆齡，不必從猜測開始",
  ctaLine: "加入 LINE 諮詢",
  ctaBooking: "預約逆齡評估",
};

/* ─── About section data (kept for other pages) ─── */
export const aboutSectionData = {
  sectionLabel: "ABOUT DR. TSENG",
  mainTitle: "讀懂你的老化程式碼",
  tags: ["醫學博士", "逆齡駭客", "AI 美學設計師"],
  description:
    "曾驛翔院長擁有超過15年醫學美容臨床經驗，專精於逆齡科技與個人化美學設計。他將醫學專業與數據科技結合，提出「老化程式除錯」理論——認為老化並非不可逆的命運，而是一套可以讀懂、分析、重寫的生物程式。透過精密的身體狀態評估與AI輔助分析，曾院長為每位客戶量身打造專屬的逆齡路線圖。",
};

/* ─── Core Values Full (core-value page) ─── */
export const coreValuesData = {
  sectionLabel: "CORE VALUE",
  title: "老化除錯",
  titleAccent: "四大核心協議",
  description:
    "我們不賣療程，我們解決問題。以程式除錯的思維，為您的老化狀態進行全面診斷與優化。",
  values: [
    {
      id: 1,
      icon: "ri-scan-line",
      title: "讀取狀態",
      subtitle: "STATUS SCAN",
      description:
        "透過精密儀器與AI演算法，全面讀取肌膚、骨骼、肌肉的老化狀態數據，建立個人老化資料庫。",
    },
    {
      id: 2,
      icon: "ri-bug-line",
      title: "除錯分析",
      subtitle: "DEBUG ANALYSIS",
      description:
        "解析老化成因與路徑，識別導致衰退的關鍵「bug」——是膠原流失、結構坍塌，還是代謝減速？",
    },
    {
      id: 3,
      icon: "ri-code-box-line",
      title: "重寫程式",
      subtitle: "REWRITE PROTOCOL",
      description:
        "依據分析結果，設計專屬逆齡路線圖。結合醫學美容科技與再生醫學，精準修復、重建、優化。",
    },
    {
      id: 4,
      icon: "ri-shield-check-line",
      title: "持續監控",
      subtitle: "MONITOR & OPTIMIZE",
      description:
        "建立長期追蹤機制，持續監控逆齡成效，動態調整方案，確保老化程式維持最佳運行狀態。",
    },
  ],
};

/* ─── Protocol data ─── */
export const protocolData = {
  title: "時光逆行四部曲",
  subtitle: "PROTOCOL",
  description:
    "一套完整的老化程式除錯流程，從狀態讀取到持續優化，四個階段為您打造專屬逆齡方案。",
  cta: "查看完整方案",
  steps: [
    {
      num: "01",
      title: "初始化掃描",
      desc: "3D臉部結構掃描、肌膚狀態檢測、骨骼肌肉評估",
    },
    {
      num: "02",
      title: "數據解碼",
      desc: "AI分析老化型態、比對逆齡資料庫、生成個人報告",
    },
    {
      num: "03",
      title: "路線圖設計",
      desc: "客製化療程規劃、階段性目標設定、預期成效預測",
    },
    {
      num: "04",
      title: "執行與監控",
      desc: "療程執行、定期追蹤、動態調整、成效驗證",
    },
  ],
};

/* ─── Equipment Preview ─── */
export const equipmentPreview = [
  {
    name: "超音波拉提系統",
    category: "結構重建",
    image:
      "https://readdy.ai/api/search-image?query=advanced%20medical%20ultrasound%20aesthetic%20device%20in%20sleek%20modern%20clinical%20setting%20with%20dark%20blue%20ambient%20lighting%2C%20professional%20medical%20equipment%20photography%2C%20high-end%20technology%2C%20clean%20minimalist%20composition&width=400&height=300&seq=eq1&orientation=landscape",
  },
  {
    name: "AI肌膚分析儀",
    category: "狀態診斷",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20AI%20skin%20analysis%20scanner%20device%20with%20holographic%20display%20interface%2C%20dark%20background%20with%20cyan%20blue%20glow%2C%20medical%20technology%20concept%2C%20sleek%20modern%20design&width=400&height=300&seq=eq2&orientation=landscape",
  },
  {
    name: "雷射再生儀",
    category: "細胞修復",
    image:
      "https://readdy.ai/api/search-image?query=advanced%20laser%20medical%20device%20for%20skin%20regeneration%2C%20dark%20clinical%20environment%20with%20teal%20and%20gold%20accent%20lighting%2C%20professional%20medical%20aesthetic%20equipment%2C%20futuristic%20design&width=400&height=300&seq=eq3&orientation=landscape",
  },
  {
    name: "3D臉部建模系統",
    category: "精準規劃",
    image:
      "https://readdy.ai/api/search-image?query=3D%20facial%20scanning%20modeling%20system%20display%20screen%20showing%20wireframe%20face%20model%2C%20dark%20background%20with%20blue%20green%20glow%2C%20medical%20imaging%20technology%2C%20futuristic%20interface%20design&width=400&height=300&seq=eq4&orientation=landscape",
  },
];

/* ─── Knowledge Preview (kept for knowledge page) ─── */
export const knowledgePreview = {
  sectionLabel: "KNOWLEDGE BASE",
  title: "逆齡知識庫",
  articles: [
    {
      title: "您是哪一種正在變老的型態？",
      excerpt: "解析六種常見老化型態，找到您的老化「bug」，才能對症下藥。",
      path: "/aging-types",
      tag: "老化診斷",
    },
    {
      title: "膠原蛋白流失的時間軸",
      excerpt: "從25歲開始，膠原蛋白以每年1%的速度遞減。了解時間軸，掌握逆齡先機。",
      path: "/articles",
      tag: "專欄",
    },
    {
      title: "為什麼保養品無法逆轉結構性老化？",
      excerpt: "當老化從表皮層深入到筋膜層，光靠保養品已無法觸及核心問題。",
      path: "/articles",
      tag: "專欄",
    },
  ],
};

/* ─── CTA Section Data (legacy, used by other pages) ─── */
export const ctaSectionData = {
  label: "// INITIATE BOOKING SEQUENCE",
  titleLine1: "預約你的",
  titleLine2: "逆齡路線圖評估",
  highlight: "逆齡路線圖",
  ctaPrimary: "立即線上預約",
  ctaLine: "加入 LINE 諮詢",
};

/* ─── About Page Data ─── */
export const aboutPageData = {
  heroTitle: "關於時光逆行駭客｜曾驛翔院長",
  heroSubtitle:
    "「變老」不是一夕之間發生，而是一行行程式碼默默運作的結果。身為皮膚科出身、投入醫學美容與功能性醫療的醫師，曾驛翔院長用「駭客」的眼光，找出你身體與外表老化的關鍵節點，重新設計青春、體態與精神狀態的運作方式。",
  heroTagline: "// ABOUT CHRONOHACKER",
  whatIs: {
    label: "// WHAT IS CHRONOHACKER",
    cards: [
      {
        title: "不是「凍齡魔術」，而是「老化程式除錯」",
        desc: "很多人來到醫美診間時，已經覺得自己老得太快：男性突然發現肚子變大、體力跟不上壓力；女性看見鏡子裡的斑點、鬆弛與暗沉；熟齡與長青族則在意走路穩不穩、有沒有精神面對每一天。「時光逆行駭客」不是推銷某個單一療程，而是像駭客讀程式一樣，先找出你目前狀態背後的原因。",
      },
      {
        title: "懶人也能執行的逆齡系統",
        desc: "很多計畫失敗，不是方法不好，而是太難執行、太不符合現實生活。曾院長在設計方案時，會先了解你的工作型態、家庭壓力與可投入時間，再決定要把資源放在哪裡。",
      },
    ],
  },
  rules: {
    label: "// ACTION RULES",
    title: "時光逆行駭客的三個行動準則",
    items: [
      {
        num: "01",
        title: "先找出問題，而不是先開清單",
        desc: "真正的駭客，在動手之前會先讀懂程式。逆齡也是一樣，先了解身體與外表目前卡在哪裡，再談療程或調整方式。",
      },
      {
        num: "02",
        title: "把逆齡做成你真的做得到的版本",
        desc: "不是每個人都能每天運動、完美飲食、準時睡覺。真正有用的方案，要符合生活現實。",
      },
      {
        num: "03",
        title: "尊重每個年齡的樣子，不盲目追求同一種美",
        desc: "20 歲、40 歲、60 歲的美感本來就不一樣。時光逆行不是把所有人都變成同一個樣子，而是讓你在當下年齡，看起來是最適合你的人生版本。",
      },
    ],
  },
  qa: {
    label: "// Q&A",
    title: "常見問題",
    items: [
      {
        q: '「時光逆行駭客」會保證一定變年輕嗎？',
        a: "不會也不能保證。醫學與身體都有界線，每個人的基因、體質、生活環境都不同。時光逆行駭客能做的，是盡可能找出可以被調整的地方，避免不必要的傷害與風險。",
      },
      {
        q: "一定要做很多醫美療程才適合來找曾院長嗎？",
        a: "不一定。有些人適合多一點儀器與療程，有些人則更適合從生活與功能性醫療調整入手。重點不是做多少，而是為什麼做、是否適合現在的狀態。",
      },
    ],
  },
  profile: {
    label: "// PROFILE",
    title: "曾驛翔 院長",
    subtitle: "皮膚科背景｜醫學美容・功能性醫療整合",
    tags: ["皮膚科背景", "醫學美容", "功能性醫療", "個人形象 IP", "時光逆行駭客", "青春駭客", "時光修復所 所長"],
    description:
      "「時光逆行駭客」這個形象 IP，不是承諾讓時間倒轉，而是陪你一起理解：為什麼會老得那麼快？哪一些可以調整？哪些需要尊重與接納？然後，用你做得到的節奏，一步步把自己變回喜歡的樣子。",
  },
  bottomCta: {
    label: "// NEXT STEP",
    title: "想知道你的老化程式卡在哪裡？",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Core Value Page Data ─── */
export const coreValuePageData = {
  heroTitle: "時光逆行駭客的核心價值",
  heroSubtitle:
    "「變老」不是突然，而是一行行程式逐漸跑出來的結果。時光逆行駭客關注的不是魔術，而是找出老化背後的邏輯與原因，並建立一套你真正做得到、且能持續更新的逆齡系統。",
  heroTagline: "// CORE VALUE",
  cards: [
    {
      icon: "ri-bug-line",
      num: "01",
      title: "老化程式除錯，而不是凍齡魔術",
      subtitle: "Debug your aging code.",
      desc: "時光逆行駭客不推銷單一療程，而是像駭客一樣先讀懂你的狀態：生活型態、荷爾蒙變化、壓力、睡眠、體檢數據與膚況，找出真正讓你變老的關鍵節點。",
    },
    {
      icon: "ri-dashboard-3-line",
      num: "02",
      title: "懶人也能做到的逆齡系統",
      subtitle: "Make anti-aging executable.",
      desc: "真正有效的計畫，不是理想化的完美生活，而是能放進你現實日常的版本。從儀器、療程、生活調整到追蹤回診，設計成你真的做得到的節奏。",
    },
    {
      icon: "ri-shield-check-line",
      num: "03",
      title: "安全、自然、長期，而非一次性衝刺",
      subtitle: "Safety, natural result, long-term design.",
      desc: "逆齡不是一次性衝刺，而是長期狀態管理。所有安排都應重視安全性、自然感與可持續性。",
    },
    {
      icon: "ri-user-smile-line",
      num: "04",
      title: "尊重年齡，而不是否定年齡",
      subtitle: "Respect every stage of life.",
      desc: "時光逆行不是否定年齡，而是讓你在當下階段看起來更有精神、更穩定、更接近自己喜歡的樣子。",
    },
  ],
  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "你的逆齡，不必從猜測開始",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Protocol Page Data (NEW) ─── */
export const protocolPageData = {
  heroTagline: "// REVERSE AGING PROTOCOL",
  heroTitleLine1: "先讀懂你的身體程式碼，",
  heroTitleLine2: "再設計專屬的逆齡路線圖",
  heroDesc:
    "「逆齡評估」是進入時光逆行系統的起點。不急著決定要做哪一種療程，而是先用問診、體檢數據、膚況與體態評估，找出你目前老得比較快的關鍵節點，為你設計可以真實執行的專屬方案。",
  heroSupplement:
    "每個人的年齡、體質、工作壓力與生活節奏都不同。逆齡評估的目的，是幫你釐清「現在最值得優先處理的是什麼」，並在醫學安全的前提下，提供幾種不同強度與節奏的選擇，而不是只給你一張療程價目表。",

  modules: {
    label: "// ASSESSMENT MODULES",
    title: "三大逆齡評估模組",
    items: [
      {
        num: "01",
        title: "男性懸崖式衰老評估",
        desc: [
          "體態與體脂分布、肌肉量趨勢、腹部脂肪與代謝壓力觀察",
          "睡眠品質、壓力來源、精神與性功能狀態之自我敘述與問診",
          "必要時搭配體檢數據，找出代謝、荷爾蒙與生活節奏中的關鍵問題",
        ],
        audience: "適合：30–60 歲男性、高壓工作者、體態與精神狀態突然下滑者",
        accent: "#22D3EE",
        icon: "ri-men-line",
      },
      {
        num: "02",
        title: "膚況與外觀老化評估",
        desc: [
          "青春痘、痘疤、毛孔、斑點、膚色不均與細紋鬆弛整體檢視",
          "觀察痘痘分布、出油程度、粉刺、毛孔、色素沉澱與膚質敏感度",
          "詢問保養流程與過去使用產品或療程，避免重複踩雷",
          "評估適合的醫學治療、醫美儀器或微整形強度，保持自然與安全感",
        ],
        audience: "適合：青春痘與痘疤族、斑點暗沉、毛孔粗大、臉部老化族群",
        accent: "#FACC6B",
        icon: "ri-sparkling-line",
      },
      {
        num: "03",
        title: "熟齡與長青慢老評估",
        desc: [
          "以年度或長期視角規劃，重點放在行動力、睡眠、生活品質與安全性",
          "搭配定期回診與體檢報告追蹤，必要時調整相關建議",
          "針對外觀部分，例如臉部、體態，安排可負擔且穩定的維持策略",
        ],
        audience: "適合：熟齡與長青族、或希望長期被照顧的高壓族群",
        accent: "#35E0B9",
        icon: "ri-heart-pulse-line",
      },
    ],
  },

  fourSteps: {
    label: "// FOUR-STEP PROTOCOL",
    title: "時光逆行四部曲",
    steps: [
      {
        num: "01",
        code: "SCAN",
        title: "掃描狀態",
        desc: "先了解你的膚況、體態、生活壓力、睡眠、體檢數據與最在意的問題，找出老化速度變快的可能原因。",
        icon: "ri-scan-line",
        accent: "#22D3EE",
      },
      {
        num: "02",
        code: "DEBUG",
        title: "找出關鍵節點",
        desc: "不是所有問題都要一起處理，而是先找出最影響外觀、精神或生活品質的關鍵節點。",
        icon: "ri-bug-line",
        accent: "#FACC6B",
      },
      {
        num: "03",
        code: "DESIGN",
        title: "設計逆齡路線",
        desc: "依照你的時間、預算、體質與生活型態，設計可以執行的逆齡方案，包含醫美儀器、門診追蹤、生活調整或體態管理。",
        icon: "ri-code-box-line",
        accent: "#FF8A4C",
      },
      {
        num: "04",
        code: "UPDATE",
        title: "持續追蹤更新",
        desc: "逆齡不是一次完成，而是持續觀察身體與外觀變化，再逐步調整策略。",
        icon: "ri-refresh-line",
        accent: "#35E0B9",
      },
    ],
  },

  plans: {
    label: "// PLAN OPTIONS",
    title: "三種節奏，一種態度",
    items: [
      {
        tag: "A",
        title: "輕量啟動型",
        desc: "適合第一次接觸醫美或逆齡評估者。",
        highlight: "先釐清問題、建立方向、降低焦慮。",
        accent: "#22D3EE",
        icon: "ri-rocket-line",
      },
      {
        tag: "B",
        title: "積極改善型",
        desc: "適合已經明顯感受到外觀、體態或精神狀態下滑者。",
        highlight: "安排較完整評估與階段性改善計畫。",
        accent: "#FACC6B",
        icon: "ri-speed-line",
      },
      {
        tag: "C",
        title: "長期慢老型",
        desc: "適合熟齡族、長青族或希望長期維持狀態者。",
        highlight: "年度追蹤、定期調整、穩定維持生活品質。",
        accent: "#35E0B9",
        icon: "ri-shield-check-line",
      },
    ],
  },

  faq: {
    label: "// FAQ",
    title: "常見問題",
    items: [
      {
        q: "「逆齡評估」本身就算是一種療程嗎？",
        a: "不是。逆齡評估是釐清狀態與設計方向的前置流程，實際療程或醫療安排需由醫師依個人條件評估。",
      },
      {
        q: "評估後一定要做療程嗎？",
        a: "不一定。評估的目的不是強迫消費，而是讓你知道自己目前最適合從哪裡開始。",
      },
      {
        q: "我不知道自己適合體態、膚況還是體檢，可以預約嗎？",
        a: "可以。若你同時在意很多事情，建議先透過逆齡評估抓出優先順序。",
      },
    ],
  },

  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "你的逆齡，不該從亂猜開始",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Equipment Page Data (NEW) ─── */
export const equipmentPageData = {
  heroTagline: "// EQUIPMENT & TREATMENTS",
  heroTitle: "醫美儀器不是答案，",
  heroTitleAccent: "正確評估才是逆齡的開始",
  heroDesc:
    "不同儀器與療程有不同適應狀況，也有不同風險與限制。時光逆行駭客重視的是：先了解你的膚況、體質、生活節奏與期待，再由醫師評估適合的療程工具，而不是看到熱門項目就直接照做。",

  categories: {
    label: "// TREATMENT CATEGORIES",
    title: "醫美療程分類",
    items: [
      {
        title: "膚質與光療類",
        icon: "ri-sun-line",
        accent: "#22D3EE",
        items: ["皮秒雷射", "柔膚雷射", "飛梭雷射", "水飛梭", "果酸換膚", "杏仁酸煥膚"],
      },
      {
        title: "注射與微整類",
        icon: "ri-syringe-line",
        accent: "#FACC6B",
        items: ["肉毒", "玻尿酸"],
      },
      {
        title: "拉提緊緻類",
        icon: "ri-arrow-up-line",
        accent: "#FF8A4C",
        items: ["音波拉提", "電波拉提", "緊緻類療程，例如探頭類"],
      },
      {
        title: "亮白與保養類",
        icon: "ri-sparkling-line",
        accent: "#35E0B9",
        items: ["美白針 / 點滴"],
      },
      {
        title: "體態管理類",
        icon: "ri-body-scan-line",
        accent: "#4BC0FF",
        items: ["體態管理儀器，例如增肌減脂類機器"],
      },
    ],
  },

  examples: {
    label: "// COMMON EQUIPMENT EXAMPLES",
    title: "儀器名稱示例",
    subtitle: "以下為可能使用或常見儀器示例，不代表本站一定提供所有機器：",
    items: [
      "PicoSure / Discovery Pico / 755 雷射",
      "蜂巢皮秒",
      "新型水飛梭",
      "某品牌音波 / 電波",
      "某型體雕機",
    ],
  },

  principles: {
    label: "// SELECTION PRINCIPLES",
    title: "儀器選擇原則",
    cards: [
      {
        icon: "ri-money-cny-circle-line",
        title: "不是越貴越適合",
        desc: "價格高的儀器不一定適合你的膚況與需求。正確的評估與搭配，比單一昂貴設備更重要。",
      },
      {
        icon: "ri-group-line",
        title: "不是朋友有效就一定適合你",
        desc: "每個人的膚質、體質、老化型態都不同。適合別人的療程，未必適合你。",
      },
      {
        icon: "ri-repeat-line",
        title: "不是做一次就能解決所有問題",
        desc: "老化是多面向、多層次的過程。多數狀況需要階段性規劃與持續追蹤，而非單次解決。",
      },
      {
        icon: "ri-calendar-schedule-line",
        title: "儀器搭配與間隔時間需由醫師評估",
        desc: "不同儀器的能量、作用深度與恢復期不同，如何搭配、間隔多久，需由專業醫師判斷。",
      },
    ],
  },

  compliance:
    "本頁介紹僅供一般醫學美容知識參考，實際療程項目、適應症、禁忌症、風險與效果，需由合格醫師於診間依個人條件專業評估與說明。",

  bottomCta: {
    label: "// NEXT STEP",
    title: "不知道自己適合哪一種儀器？",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Testimonials Page Data (NEW) ─── */
export const testimonialsPageData = {
  heroTagline: "// CLIENT TESTIMONY",
  heroTitle: "不是「奇蹟故事」，",
  heroTitleAccent: "只是一些真實的感受",
  heroDesc:
    "這裡收錄的是不同年齡、不同生命階段的客戶，在時光逆行駭客曾驛翔院長陪伴下的個人感受。每一則分享，都只代表當事人的主觀經驗與當時狀態，並不代表所有人都會有相同結果。",

  legalNote:
    "以下內容為個人經驗與衛教觀念分享，未涉及療效保證。實際狀況需由醫師於診間依個人條件專業評估，任何醫療或療程安排皆有其風險與限制。",

  categories: [
    {
      id: "male",
      label: "型男醫美與男性懸崖式衰老",
      icon: "ri-men-line",
      accent: "#22D3EE",
      desc: "34–56 歲男性客戶的分享：有人是因為體態，有人是因為疲勞與外表落差太大，才決定來做一次逆齡評估，並逐步調整自己的生活與外觀。",
      stories: [
        {
          id: "testimonial-male-01",
          identity: "38 歲科技業主管",
          concern: "覺得自己突然老很多",
          before: "以前覺得保養是女生的事，直到某天開會被問『最近是不是很累』，才意識到自己的外表和內在狀態落差太大。",
          during: "曾院長先評估了我的壓力來源、睡眠與體態變化，不是直接推銷療程，而是先幫我釐清哪些是可以調整的，哪些需要時間。",
          now: "現在比較知道自己該從哪裡下手，不再是亂試保養品或亂花錢。這種被理解的感覺，比任何療程都重要。",
          note: "個人感受分享，非療效保證",
        },
        {
          id: "testimonial-male-02",
          identity: "45 歲企業主",
          concern: "體態與精神狀態下滑",
          before: "公司越大，壓力越大。身邊的人都不太好意思說，但鏡子裡的自己確實在走下坡。體重、臉色、精神，都不像十年前。",
          during: "評估過程很細，會問工作節奏、家庭狀況、過去用過什麼方法。不是開一張清單就結束，而是討論哪些先做、哪些可以緩。",
          now: "目前還在進行中，但已經有方向感了。最重要的是，有人幫我『讀懂』自己的狀態，而不是要我照單全收。",
          note: "個人感受分享，非療效保證",
        },
        {
          id: "testimonial-male-03",
          identity: "56 歲熟齡男性",
          concern: "希望維持行動力與自信",
          before: "到了這個年紀，不是想要變回 30 歲，而是希望可以健康、有精神、走路穩，不要變成家人的負擔。",
          during: "評估內容包含體檢數據、行動力測試與生活品質。曾院長很尊重我的年紀，不會給不切實際的建議。",
          now: "我現在知道哪些事情可以維持、哪些需要注意。這種『被評估後的安心感』，是我覺得最有價值的地方。",
          note: "個人感受分享，非療效保證",
        },
      ],
    },
    {
      id: "acne",
      label: "青春痘、痘疤與膚況不穩",
      icon: "ri-emotion-unhappy-line",
      accent: "#FACC6B",
      desc: "針對年輕族群或長期受痘痘、痘疤、毛孔與膚況困擾者，以主觀感受與衛教角度呈現。",
      stories: [
        {
          id: "testimonial-acne-01",
          identity: "26 歲女性／上班族",
          concern: "反覆長痘、痘疤與毛孔",
          before: "從高中就開始長痘痘，試過無數保養品和偏方，皮膚反而越來越糟。最討厭的是有人說『長痘痘就是沒在保養』。",
          during: "曾院長看了我的膚況、問了過去用過的產品與療程，找出哪些成分或做法可能在惡化問題。這種『除錯』的感覺讓我覺得終於被理解了。",
          now: "現在膚況比較穩定，也知道哪些保養步驟是多餘的、哪些其實對我沒用。不是變成完美皮膚，但至少不會一直在亂試。",
          note: "個人感受分享，非療效保證",
        },
        {
          id: "testimonial-acne-02",
          identity: "32 歲男性／業務",
          concern: "痘疤明顯、膚色不均",
          before: "做業務要見客戶，臉上的痘疤讓我很沒自信。試過遮瑕，但總覺得自己在『遮』而不是『處理』。",
          during: "評估時發現我的膚質其實很容易受刺激，之前做過的某些療程反而讓膚況更敏感。曾院長建議先穩定膚況，再評估下一步。",
          now: "現在有比較清楚的理解：不是每個療程都適合我，要先評估再決定。這種『被評估』的安全感，比直接做療程還重要。",
          note: "個人感受分享，非療效保證",
        },
      ],
    },
    {
      id: "female",
      label: "女性醫美、斑點暗沉與自然感",
      icon: "ri-women-line",
      accent: "#FF8A4C",
      desc: "呈現女性對斑點、暗沉、鬆弛、輪廓與自然感的在意，強調不是追求變成別人，而是回到比較有精神的自己。",
      stories: [
        {
          id: "testimonial-female-01",
          identity: "42 歲女性／上班族",
          concern: "斑點、暗沉、臉部輪廓下滑",
          before: "每天早上化妝時都覺得自己在『修補』而不是『保養』。斑點越來越難遮，臉部線條也和五年前差很多。",
          during: "評估時，曾院長會看整體膚況、問生活習慣，也了解我的期待——不是要變成 25 歲，而是讓現在的自己看起來精神一點。",
          now: "現在比較能接受自己現在的樣子，但也知道有哪些地方可以逐步調整。不是追求『完美』，而是追求『更喜歡自己』。",
          note: "個人感受分享，非療效保證",
        },
        {
          id: "testimonial-female-02",
          identity: "48 歲女性／全職媽媽",
          concern: "鬆弛、細紋、沒有精神",
          before: "帶孩子這麼多年，終於有時間看看自己。鏡子裡的人看起來比實際年齡還累。不是抱怨，而是想知道自己還能做什麼。",
          during: "曾院長沒有給我標準答案，而是和我一起討論時間、預算與期待。有些建議很實際，有些則是『先觀察，不急著做』。",
          now: "現在有方向感了。不是每個問題都要一次解決，而是知道優先順序。最重要的是：有人尊重我『想變好』的心情，但不會給我壓力。",
          note: "個人感受分享，非療效保證",
        },
      ],
    },
    {
      id: "senior",
      label: "熟齡與長青慢老照護",
      icon: "ri-heart-pulse-line",
      accent: "#35E0B9",
      desc: "呈現熟齡族與家屬對生活品質、行動力、精神狀態與長期陪伴的重視。",
      stories: [
        {
          id: "testimonial-senior-01",
          identity: "62 歲女性／退休教師",
          concern: "希望維持行動力與生活品質",
          before: "退休後想好好過日子，但發現體力、精神與以前差很多。不是想變年輕，而是希望可以維持現在的狀態久一點。",
          during: "評估內容很全面，不只是看外表，也問睡眠、飲食、活動量與家庭支持。曾院長把重點放在『維持』而不是『改變』。",
          now: "現在每季回診一次，調整一些生活細節與外觀維護。感覺有人『陪著』我變老，而不是要我『抵抗』老化。",
          note: "個人感受分享，非療效保證",
        },
        {
          id: "testimonial-senior-02",
          identity: "58 歲男性／家屬陪同",
          concern: "家人希望協助長輩維持狀態",
          before: "我爸最近走路有點不穩，精神也差。帶他來不只是為了外表，而是希望有個專業的人幫我們評估整體狀況。",
          during: "評估過程中，曾院長很耐心地和長輩溝通，也會解釋給家屬聽。感覺不只是醫師，更像是幫我們一起規劃未來的人。",
          now: "現在定期回診，調整一些建議與外觀維護。最重要的是：我爸覺得自己被重視、被理解，而不是被當成『病人』。",
          note: "個人感受分享，非療效保證",
        },
      ],
    },
  ],

  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "也想知道自己的逆齡路線？",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Stories Page Data (NEW) ─── */
export const storiesPageData = {
  heroTagline: "// REAL STORIES",
  heroTitle: "真實",
  heroTitleAccent: "故事",
  heroDesc:
    "深入每一位客戶的逆齡旅程，了解他們從評估到調整的完整過程。每一段故事，都是個人化的老化程式除錯記錄。",

  legalNote:
    "以下內容為個人經驗與衛教觀念分享，未涉及療效保證。實際狀況需由醫師於診間依個人條件專業評估，任何醫療或療程安排皆有其風險與限制。",

  stories: [
    {
      id: "story-01",
      tag: "型男醫美",
      tagAccent: "#22D3EE",
      title: "38 歲科技業主管：覺得自己突然老很多",
      identity: "38 歲男性／科技業主管",
      concern: "外表與精神狀態和實際年齡落差大，被同事問『最近是不是很累』",
      excerpt:
        "從沒想過自己會走進醫美診間。以前覺得保養是女生的事，直到某天會議後，一位同事無心的一句『你是不是最近很累？』讓我意識到，自己的臉和 28 歲時已經完全不同。",
      process:
        "曾院長的第一個問題不是『你想做什麼療程』，而是『你最近的生活節奏是什麼樣子？』。評估過程中，我們討論了壓力來源、睡眠品質、體重變化與過去用過的保養方式。我才發現，很多問題其實和『保養』無關，而是和『生活方式』有關。",
      result:
        "現在不是變年輕了，而是比較知道自己在幹嘛。哪些東西值得投資時間和金錢，哪些只是廣告話術。這種『被評估後的清醒感』，是我覺得最值得的地方。",
      note: "個人感受分享，非療效保證",
    },
    {
      id: "story-02",
      tag: "女性醫美",
      tagAccent: "#FF8A4C",
      title: "42 歲上班族：每天早上都在修補自己的臉",
      identity: "42 歲女性／上班族",
      concern: "斑點、暗沉、臉部輪廓下滑，每天早上化妝像是在修補",
      excerpt:
        "每天早上化妝的時間越來越長。遮瑕膏從一支變成三支，粉底從薄擦變成厚蓋。最後發現，與其每天花半小時『修補』，不如花一次時間『了解』自己的臉到底發生什麼事。",
      process:
        "評估時，曾院長先看整體膚況，問我過去的保養流程、用過的產品、做過的療程。發現很多步驟其實是重複或無效的。重點不是加更多東西，而是先找出哪些東西在傷害我的皮膚。",
      result:
        "現在我的保養流程簡化很多，也比較知道哪些療程適合我、哪些不適合。不是變成完美皮膚，但至少不再每天和鏡子打仗。",
      note: "個人感受分享，非療效保證",
    },
    {
      id: "story-03",
      tag: "熟齡慢老",
      tagAccent: "#35E0B9",
      title: "62 歲退休教師：有人陪著變老，比變年輕更重要",
      identity: "62 歲女性／退休教師",
      concern: "退休後體力與精神下滑，希望可以維持現有狀態",
      excerpt:
        "退休後以為可以好好過日子，但發現體力、睡眠、精神都和以前差很多。不是想變回 40 歲，而是希望可以維持現在的樣子久一點，不要快速走下坡。",
      process:
        "曾院長的評估很全面，不只是看臉，也問走路穩不穩、睡得好不好、吃什麼、動多少。然後把重點放在『維持』和『預防』，而不是『改變』。這種態度讓我很安心。",
      result:
        "現在每季回診一次，調整一些生活細節與外觀維護。感覺有人『陪著』我變老，而不是要我『抵抗』老化。這種被理解與被陪伴的感覺，比任何療程都珍貴。",
      note: "個人感受分享，非療效保證",
    },
  ],

  bottomCta: {
    label: "// NEXT CHAPTER",
    title: "你的逆齡故事，從一次評估開始",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Knowledge Page Data (NEW) ─── */
export const knowledgePageData = {
  heroTagline: "// KNOWLEDGE BASE",
  heroTitle: "不是網路謠言，",
  heroTitleAccent: "而是可以放心查閱的逆齡筆記",
  heroDesc:
    "「逆齡知識庫」整理的是曾驛翔院長在看診與衛教過程中，常被問到的問題與觀念說明。內容以中立、易懂、接地氣為原則，幫助你在做任何決定之前，先弄懂幾個重要前提。",
  heroNote:
    "本頁內容僅供一般健康與醫學美容觀念參考，無法取代親自門診、身體檢查與醫師專業診斷。若有實際症狀或不適，請盡速就醫，由合格醫師診治。",

  categories: {
    label: "// KNOWLEDGE CATEGORIES",
    title: "五大逆齡觀念分類",
    items: [
      {
        title: "男性懸崖式衰老與體態管理",
        icon: "ri-men-line",
        accent: "#22D3EE",
        desc: "很多男性不是慢慢老，而是某一天突然發現肚子大了、體力下滑、精神不濟。此分類整理男性老化、體態與生活節奏相關觀念。",
        path: "/articles",
      },
      {
        title: "青春痘、痘疤與膚況管理",
        icon: "ri-emotion-unhappy-line",
        accent: "#FACC6B",
        desc: "從青春痘、粉刺、出油、毛孔、痘疤到膚況不穩，整理常見問題與照護觀念。",
        path: "/articles",
      },
      {
        title: "醫美與微整觀念",
        icon: "ri-hospital-line",
        accent: "#FF8A4C",
        desc: "說明常見醫美儀器、療程選擇、自然感、安全性與風險觀念。",
        path: "/equipment",
      },
      {
        title: "熟齡與長青族慢老",
        icon: "ri-heart-pulse-line",
        accent: "#35E0B9",
        desc: "從行動力、精神狀態、生活品質、長期照護與家庭陪伴角度，理解慢老不是只看外表。",
        path: "/articles",
      },
      {
        title: "常見迷思與 FAQ",
        icon: "ri-question-line",
        accent: "#4BC0FF",
        desc: "破解最常見的逆齡迷思，建立正確觀念再開始行動。",
        path: "/articles",
      },
    ],
  },

  myths: {
    label: "// COMMON MYTHS",
    title: "常見迷思與 FAQ",
    items: [
      {
        q: "「只要找到對的儀器或療程，就可以一次解決所有問題？」",
        a: "現實中，沒有任何一種療程可以同時解決所有狀況。多數時候需要搭配生活習慣調整、體檢結果追蹤與循序漸進的醫療計畫。",
      },
      {
        q: "「醫美或逆齡，就是要看起來完全不像自己？」",
        a: "逆齡的核心不是變成別人，而是讓你更接近自己理想中的狀態：看起來比較有精神、對鏡子裡的自己更有好感、身體功能維持在能享受生活的範圍內。",
      },
      {
        q: "「只要年輕人或網紅在做，就一定適合我？」",
        a: "每個人的皮膚、體質與疾病史不同，同樣療程在不同人身上，風險與效果也會不同。任何療程安排都應該以醫師評估為主，而不是單看網路心得或廣告。",
      },
      {
        q: "「我適合從哪裡開始？體態？膚況？還是體檢？」",
        a: "若你同時在意很多事情，建議先預約一次逆齡評估，把體檢報告、目前最困擾的 1–3 件事帶來，由曾驛翔院長協助抓出優先順序。",
      },
    ],
  },

  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "看完觀念，想知道自己從哪裡開始？",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Aging Types Page Data (NEW) ─── */
export const agingTypesPageData = {
  heroTagline: "// AGING TYPE DIAGNOSIS",
  heroTitle: "你是哪一種",
  heroTitleAccent: "正在變老？",
  heroDesc:
    "從男性懸崖式衰老、過勞上班族、忙碌小資貴婦、功能下滑熟齡族到小心維持的長青族，你屬於哪一種正在變老？透過分眾角色 × 症狀 × 情境敘事，幫你看見自己的老化軌跡。",

  types: [
    {
      code: "TYPE A",
      title: "突然斷崖式下滑的男性",
      gender: "男性",
      ageRange: "35–60 歲",
      accent: "#22D3EE",
      icon: "ri-men-line",
      symptoms: ["肚子變大", "體力下降", "精神疲勞", "代謝壓力", "外表突然老很多"],
      scenario:
        "以前熬夜還撐得住，現在一忙就累、照鏡子覺得自己像老了十歲。",
      cta: "預約逆齡評估，由醫師協助釐清優先順序。",
    },
    {
      code: "TYPE B",
      title: "沒有時間照顧自己的過勞上班族",
      gender: "上班族",
      ageRange: "30–50 歲",
      accent: "#FACC6B",
      icon: "ri-briefcase-line",
      symptoms: ["眼下凹陷", "氣色黯淡", "壓力大", "睡眠不足", "沒時間運動"],
      scenario:
        "你在電梯裡看到鏡子反射的自己，突然很想問：「我什麼時候開始長得像這樣？」",
      cta: "預約逆齡評估，由醫師協助釐清優先順序。",
    },
    {
      code: "TYPE C",
      title: "鏡子前嘆氣的美肌控",
      gender: "女性",
      ageRange: "25–50 歲",
      accent: "#FF8A4C",
      icon: "ri-women-line",
      symptoms: ["斑點", "膚色不均", "毛孔粗大", "痘疤", "細紋", "怕不自然"],
      scenario:
        "不是不打扮，而是怎麼打都覺得差一點。粉底越來越厚，卻還是遮不住疲態。",
      cta: "預約逆齡評估，由醫師協助釐清優先順序。",
    },
    {
      code: "TYPE D",
      title: "功能慢慢下滑的熟齡族",
      gender: "熟齡族",
      ageRange: "50–70 歲",
      accent: "#35E0B9",
      icon: "ri-heart-pulse-line",
      symptoms: ["體力下降", "睡眠品質差", "行動力變弱", "精神不穩", "外觀鬆弛"],
      scenario:
        "不一定想變年輕二十歲，只希望看起來有精神，身體能穩定享受生活。",
      cta: "預約逆齡評估，由醫師協助釐清優先順序。",
    },
    {
      code: "TYPE E",
      title: "小心維持的長青族",
      gender: "長青族",
      ageRange: "65 歲以上",
      accent: "#4BC0FF",
      icon: "ri-shield-check-line",
      symptoms: ["行動力", "安全感", "長期照護", "家屬陪伴", "生活品質"],
      scenario:
        "對長青族來說，逆齡不是追求外表年輕，而是希望維持行動力、精神與生活品質。",
      cta: "預約逆齡評估，由醫師協助釐清優先順序。",
    },
  ],

  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "找到你的老化型態了嗎？下一步是評估。",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Articles Page Data (NEW) ─── */
export const articlesPageData = {
  heroTagline: "// ARTICLES",
  heroTitle: "專欄",
  heroTitleAccent: "文章",
  heroDesc:
    "曾驛翔院長的逆齡觀點與專業知識分享。從男性懸崖式衰老、青春痘照護到熟齡慢老，整理實用且中立的醫學美容與健康管理觀念。",

  categories: [
    { id: "male", label: "男性逆齡" },
    { id: "acne", label: "青春痘與膚況" },
    { id: "equipment", label: "醫美儀器觀念" },
    { id: "senior", label: "熟齡慢老" },
    { id: "body", label: "體態管理" },
    { id: "myth", label: "常見迷思" },
  ],

  articles: [
    {
      id: "article-01",
      title: "為什麼有些男性是突然老很多？",
      category: "熟齡慢老",
      categoryLabel: "男性逆齡",
      accent: "#22D3EE",
      excerpt:
        "男性老化常被忽視，因為不像女性有明顯的更年期信號。但許多男性在 35–50 歲之間，會突然感受到體力、體態與精神的全面下滑。這篇文章從荷爾蒙變化、壓力累積與生活節奏角度，說明為什麼「懸崖式衰老」不是錯覺。",
      date: "2026.04.15",
      content: [
        "很多男性不是慢慢老，而是某一天突然發現：肚子變大了、體力下滑了、精神不如以往了。這種現象被稱為「懸崖式衰老」，其實在醫學上有跡可循。",
        "男性從三十歲後，睪固酮開始以每年約 1% 的速度遞減。這不只是影響性功能，更直接關聯到肌肉量、骨密度、脂肪分布與精神狀態。當肌肉量減少、基礎代謝下降，脂肪就容易堆積在腹部，形成「中年發福」。",
        "再加上高壓工作環境，許多男性長期處於慢性壓力中，皮質醇過高會進一步抑制睪固酮分泌，形成惡性循環。熬夜、飲酒、缺乏運動，則是加速這一切的催化劑。",
        "但最常被忽略的，是男性對自己身體變化的敏感度較低。很多女性會注意到皮膚、體重的細微變化，男性往往等到問題變得很明顯，才開始意識到「我好像老了」。",
        "逆齡評估的目的，不是讓你回到二十歲，而是找出哪些生活習慣、荷爾蒙變化與代謝壓力是可以調整的。透過體檢數據、生活習慣問診與專業評估，可以釐清優先順序，建立可執行的改善計畫。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。",
      ],
    },
    {
      id: "article-02",
      title: "青春痘不是青春期才會發生：成人痘的常見原因",
      category: "熟齡慢老",
      categoryLabel: "青春痘與膚況",
      accent: "#FACC6B",
      excerpt:
        "許多人以為長痘痘是「沒洗乾淨」或「吃太多油炸」，但成人痘的成因往往更複雜：荷爾蒙波動、壓力、保養品成分、甚至過度清潔都可能惡化膚況。本文從皮膚科角度，解析成人痘的常見原因與照護觀念。",
      date: "2026.03.28",
      content: [
        "成人痘已經不是新聞，但很多人還是把它當成「年輕時的問題」。實際上，門診中有越來越多二十五歲以上的患者，因為反覆長痘、痘疤與膚況不穩來求診。",
        "成人痘和青春痘最大的不同，在於成人痘往往不是單一原因造成。荷爾蒙波動是常見的背後推手：女性的月經週期、多囊性卵巢症候群，或男性壓力造成的荷爾蒙失調，都可能讓皮脂分泌異常。",
        "壓力是另一個被低估的因素。當皮質醇升高，皮脂腺的活躍度也會增加，同時身體的修復能力下降，痘痘自然容易反覆。更糟的是，壓力還會讓人熬夜、亂吃東西，進一步惡化膚況。",
        "很多人以為痘痘多就是「沒洗乾淨」，於是過度清潔，用過強的洗面乳或頻繁去角質。結果反而破壞皮膚屏障，讓發炎更嚴重。其實，痘痘肌的保養核心應該是「溫和清潔 + 保濕修復」，而不是一味控油。",
        "保養品成分也是需要檢視的重點。有些產品含有致粉刺成分，或是太厚重的乳霜，都可能堵塞毛孔。建議在皮膚科醫師的協助下，釐清自己的膚況類型，選擇適合的保養與治療方案。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。",
      ],
    },
    {
      id: "article-03",
      title: "醫美儀器越貴越好嗎？先懂評估再談療程",
      category: "熟齡慢老",
      categoryLabel: "醫美儀器觀念",
      accent: "#FF8A4C",
      excerpt:
        "市面上醫美儀器推陳出新，價格與宣傳也水漲船高。但儀器只是工具，真正重要的是：你的膚況適合什麼、現階段最需要處理什麼、以及如何與生活習慣搭配。本文從評估優先的角度，幫助你建立正確的儀器選擇觀念。",
      date: "2026.03.10",
      content: [
        "走進醫美診間，很容易被琳瑯滿目的儀器名稱搞得眼花撩亂。皮秒、音波、電波、水飛梭……每一台的價格都不便宜，但越貴真的越適合你嗎？",
        "答案是：不一定。醫美儀器的效果，高度依賴「誰來操作」以及「是否適合你的膚況」。同樣一台雷射儀器，在不同膚質、不同年齡、不同皮膚問題的人身上，效果可能天差地遠。",
        "評估應該先於療程。在決定做任何儀器之前，專業的醫師會先評估你的皮膚厚度、敏感度、色素沉澱類型、油脂分泌程度，以及過去的保養與治療史。這些資訊決定了你適合哪種能量、哪種波長、哪種深度。",
        "另一個常見的迷思是「一次解決所有問題」。現實中，皮膚的老化與問題是多層次的：表皮、真皮、筋膜層各自需要不同的處理方式。想要一次打雷射又拉提又美白，往往效果打折，甚至增加副作用風險。",
        "正確的觀念應該是：先找出你最困擾的 1–2 個問題，優先處理，再逐步調整。儀器搭配與治療間隔，也必須由醫師根據你的恢復狀況來判斷。急於求成，反而是對皮膚的傷害。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。",
      ],
    },
    {
      id: "article-04",
      title: "斑點、暗沉、毛孔粗大，該從哪裡開始處理？",
      category: "熟齡慢老",
      categoryLabel: "青春痘與膚況",
      accent: "#FACC6B",
      excerpt:
        "臉上的問題百百種，但資源與時間有限。斑點、暗沉與毛孔的成因不同，處理優先順序也不同。本文從皮膚科評估角度，說明如何判斷自己的膚況優先順序，避免一次做太多反而傷害皮膚。",
      date: "2026.02.22",
      content: [
        "很多來診間的人，會一口氣列出五到十個想改善的問題：斑點、暗沉、毛孔、痘疤、細紋、鬆弛……但資源與時間都有限，到底該從哪裡開始？",
        "從皮膚科評估的角度，第一步永遠是「釐清成因」。同樣是「斑點」，曬斑、肝斑、發炎後色素沉澱的處理方式完全不同。曬斑可以用雷射有效處理，肝斑卻可能因雷射而惡化，必須先以藥物與保養控制。",
        "暗沉也是多重因素造成的：角質堆積、血液循環不良、色素沉澱、膠原流失導致的透光度下降。不同的原因，對應不同的處理策略。如果沒先搞清楚原因，亂做療程可能只是花錢傷皮膚。",
        "毛孔問題更複雜。毛孔變大有幾種成因：出油型、老化型、發炎型。出油型需要控油與清潔；老化型需要刺激膠原增生；發炎型則要先控制發炎。如果混為一談，效果自然不理想。",
        "正確的優先順序應該是：先處理發炎與敏感、再處理色素、最後才處理紋理與鬆弛。皮膚的耐受度是有限的，一次做太多項目，不僅效果打折，還可能引發新的問題。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。",
      ],
    },
    {
      id: "article-05",
      title: "熟齡慢老不是只看外表，而是生活品質管理",
      category: "女性醫美",
      categoryLabel: "熟齡慢老",
      accent: "#35E0B9",
      excerpt:
        "對熟齡族與長青族來說，逆齡不只是臉部的問題。行動力、睡眠品質、精神狀態、家庭互動與生活安全感，都是「慢老」的重要面向。本文從功能性醫療與長期照護角度，說明熟齡慢老的完整觀念。",
      date: "2026.02.05",
      content: [
        "很多人一聽到逆齡，就聯想到醫美、拉提、除皺。但對熟齡族與長青族來說，真正的挑戰往往不是外表，而是行動力、精神狀態與生活品質。",
        "慢老的核心觀念是：維持功能，而不是抵抗年齡。走路穩不穩、睡得好不好、有沒有力氣做喜歡的事、記憶力與專注力是否下降，這些都是比看起來年輕幾歲更重要的指標。",
        "從功能性醫療的角度，熟齡族的健康維護應該包含：肌肉量與骨密度的維持、心血管風險的控制、認知功能的評估、以及情緒與社交活動的支持。這些面向環環相扣，缺一不可。",
        "家庭支持系統也是慢老的關鍵。有穩定的家庭互動、社交連結與情感支持的人，往往活得更久、更有活力。長青族不是等著被照顧的對象，而是應該持續參與社會、維持自己生活主導權的角色。",
        "逆齡評估對熟齡族來說，目的不是變回五十歲，而是找出維持現有功能的方法，並預防快速退化。定期回診、追蹤體檢數據、調整生活細節，這些才是真正有效的慢老策略。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。"
      ],
    },
    {
      id: "article-06",
      title: "逆齡評估前，你可以先準備哪些資料？",
      category: "熟齡慢老",
      categoryLabel: "常見迷思",
      accent: "#4BC0FF",
      excerpt:
        "第一次預約逆齡評估，很多人不知道該帶什麼、該問什麼。本文整理了一份簡單的「評估前準備清單」，幫助你在會談前整理思緒，讓評估更聚焦、更有效率。",
      date: "2026.01.18",
      content: [
        "第一次預約逆齡評估，你可能會想：我需要帶什麼？要準備什麼問題？會談會不會很長？這篇文章幫你提前整理，讓第一次見面更有效率。",
        "首先，如果你近一年內有做過體檢，建議帶上體檢報告。血糖、血脂、肝腎功能、荷爾蒙指數等數據，都能幫助醫師更快了解你的代謝狀態與潛在風險。",
        "其次，整理你目前最困擾的 1–3 件事。不需要列出所有問題，而是找出最影響你日常生活、工作或心情的。這會幫助醫師在評估時抓住重點，而不是被太多資訊分散注意力。",
        "另外，記錄你目前的保養與治療史。用過什麼保養品、做過什麼療程、有沒有藥物過敏或慢性疾病，這些資訊都能避免重複踩雷或開出衝突的處方。",
        "最後，保持開放的心態。逆齡評估的目的不是推銷療程，而是釐清你的狀態與可行的方向。帶著好奇與誠實來，才能獲得真正適合你的建議。",
        "本內容為衛教觀念分享，不代表療效保證。實際狀況需由醫師於診間依個人條件專業評估。"
      ],
    },
  ],

  bottomCta: {
    label: "// INITIATE BOOKING SEQUENCE",
    title: "讀完觀念，想親自評估自己的狀態？",
    ctaLine: "加入 LINE 諮詢",
    ctaBooking: "預約逆齡評估",
  },
};

/* ─── Events Page Data (NEW) ─── */
export const eventsPageData = {
  heroTagline: "// EVENTS & COOPERATION",
  heroTitle: "讓「逆齡」從個人診間，",
  heroTitleAccent: "走進企業與日常現場",
  heroDesc:
    "時光逆行駭客曾驛翔醫師，將青春痘、男性懸崖式衰老、體態健康、熟齡慢老等議題，轉化為企業、社群與機構聽得懂的語言與可行動的方案。",
  heroNote:
    "本頁內容為「活動與合作形式」說明，並非醫療行為或療程廣告。實際醫療項目與治療相關資訊，僅能於合法醫療院所內，由醫師依法規說明。",

  lectures: {
    label: "// LECTURES",
    title: "逆齡講座與專題分享",
    targetLabel: "適合對象",
    target: "企業、協會、學校、社團、會員制社群",
    topics: [
      { title: "男性懸崖式衰老與高壓工作者健康", icon: "ri-men-line", accent: "#22D3EE" },
      { title: "青春痘與皮膚管理", icon: "ri-emotion-unhappy-line", accent: "#FACC6B" },
      { title: "體態健康與代謝管理", icon: "ri-body-scan-line", accent: "#FF8A4C" },
      { title: "熟齡慢老與生活品質", icon: "ri-heart-pulse-line", accent: "#35E0B9" },
      { title: "醫美安全與自然感觀念", icon: "ri-shield-check-line", accent: "#4BC0FF" },
    ],
  },

  upcomingEvents: {
    label: "// UPCOMING EVENTS",
    title: "近期活動",
    events: [
      {
        id: "event-01",
        title: "男性懸崖式衰老：從察覺到改善",
        date: "2026.05.24（六）14:00–16:00",
        targetDate: "2026-05-24T14:00:00",
        location: "台北市中正區忠孝東路一段XX號X樓",
        description: "針對 35–55 歲高壓男性的專題講座，從荷爾蒙、代謝與生活節奏角度，解析為什麼有些男性會「突然老很多」，以及如何建立可執行的逆齡策略。",
        spots: "限額 30 名",
        spotsLeft: 8,
        isFull: false,
        image: "https://readdy.ai/api/search-image?query=professional%20male%20health%20seminar%20with%20modern%20dark%20conference%20interior%2C%20holographic%20body%20scan%20visualization%20on%20screen%2C%20sophisticated%20blue%20cyan%20ambient%20lighting%2C%20corporate%20wellness%20event%20atmosphere%2C%20audience%20seated%20in%20elegant%20auditorium%2C%20cinematic%20photography%2C%20no%20text%20no%20faces&width=600&height=400&seq=event-01&orientation=landscape",
        accent: "#22D3EE",
      },
      {
        id: "event-02",
        title: "青春痘與成人痘：不再亂試保養品",
        date: "2026.06.07（六）14:00–16:00",
        targetDate: "2026-06-07T14:00:00",
        location: "台北市大安區XX路XX號X樓",
        description: "從皮膚科角度解析青春痘與成人痘的成因：荷爾蒙、壓力、保養品成分與過度清潔。適合反覆長痘、痘疤困擾、膚況不穩的成年男女。",
        spots: "限額 25 名",
        spotsLeft: 0,
        isFull: true,
        image: "https://readdy.ai/api/search-image?query=modern%20skincare%20wellness%20seminar%20with%20soft%20warm%20lighting%2C%20elegant%20audience%20in%20dark%20conference%20room%2C%20glowing%20holographic%20skin%20cell%20visualization%20on%20large%20screen%2C%20professional%20health%20education%20event%2C%20minimal%20text%2C%20no%20faces%20visible%2C%20cinematic%20quality&width=600&height=400&seq=event-02&orientation=landscape",
        accent: "#FACC6B",
      },
      {
        id: "event-03",
        title: "熟齡慢老：維持行動力與生活品質",
        date: "2026.06.21（六）10:00–12:00",
        targetDate: "2026-06-21T10:00:00",
        location: "台北市信義區XX路XX號X樓",
        description: "為熟齡族與長青族設計的健康講座，不談醫美推銷，而是聚焦行動力、睡眠品質、精神狀態與家庭互動。適合 50–70 歲及家屬一同參加。",
        spots: "限額 20 名",
        spotsLeft: 3,
        isFull: false,
        image: "https://readdy.ai/api/search-image?query=elegant%20senior%20wellness%20seminar%20in%20bright%20modern%20community%20center%2C%20warm%20golden%20and%20teal%20ambient%20lighting%2C%20seniors%20and%20family%20members%20listening%20attentively%2C%20health%20data%20holographic%20display%2C%20comfortable%20chairs%2C%20cinematic%20photography%2C%20no%20text%20no%20faces&width=600&height=400&seq=event-03&orientation=landscape",
        accent: "#35E0B9",
      },
    ],
  },

  registration: {
    label: "// EVENT REGISTRATION",
    title: "活動報名",
    subtitle: "填寫表單報名近期活動，我們將於活動前寄送確認信與詳細資訊。",
  },

  corporate: {
    label: "// CORPORATE HEALTH",
    title: "讓員工從「撐住」變成「真的有狀態」",
    desc: "針對高壓工作者、主管、業務團隊與長時間用腦族群，設計可理解、可行動、不恐嚇的健康與逆齡講座。",
    features: [
      { icon: "ri-briefcase-line", text: "針對高壓與長時間用腦族群" },
      { icon: "ri-group-line", text: "可理解、不恐嚇的內容語言" },
      { icon: "ri-lightbulb-line", text: "提供可行動的日常建議" },
      { icon: "ri-calendar-check-line", text: "可配合企業內訓時段安排" },
    ],
  },

  partnership: {
    label: "// PARTNERSHIP",
    title: "異業合作",
    desc: "歡迎各類型品牌、機構與平台共同推廣逆齡與健康管理觀念。",
    partners: [
      { icon: "ri-run-line", label: "健身房" },
      { icon: "ri-brush-line", label: "美業品牌" },
      { icon: "ri-drop-line", label: "保養品品牌" },
      { icon: "ri-building-2-line", label: "企業內訓單位" },
      { icon: "ri-mic-line", label: "社群與講座平台" },
      { icon: "ri-parent-line", label: "熟齡照護相關單位" },
    ],
  },

  process: {
    label: "// COOPERATION PROCESS",
    title: "合作流程",
    steps: [
      { num: "01", title: "提出合作需求", desc: "透過 LINE 或線上表單說明合作類型與大致方向。" },
      { num: "02", title: "確認講座主題與對象", desc: "討論目標聽眾、人數、時間與場地條件。" },
      { num: "03", title: "設計內容大綱", desc: "依據對象與目標，客製化講座內容與互動環節。" },
      { num: "04", title: "確認日期、場地與形式", desc: "敲定線上或實體、時間長度與設備需求。" },
      { num: "05", title: "活動執行", desc: "曾驛翔醫師親自到場或線上參與，進行講座與互動。" },
      { num: "06", title: "後續諮詢與追蹤", desc: "提供講座資料與後續聯繫窗口，協助延伸服務。" },
    ],
  },

  bottomCta: {
    label: "// INITIATE COOPERATION",
    title: "想邀請曾驛翔醫師進行講座或合作？",
    ctaLine: "加入 LINE 洽談合作",
    ctaBooking: "線上預約諮詢",
  },
};

/* ─── Booking Page Data (NEW) ─── */
export const bookingPageData = {
  heroTagline: "// INITIATE BOOKING SEQUENCE",
  heroTitle: "預約你的逆齡評估，",
  heroTitleAccent: "從釐清狀態開始",
  heroDesc:
    "線上預約時光逆行駭客門診：逆齡評估、男性懸崖式衰老、青春痘與膚況、體態管理、熟齡與長青族慢老諮詢。填寫表單後將由專人與您聯繫確認時段，尚非完成掛號或醫療行為。",

  formLabels: {
    name: "姓名",
    gender: "性別",
    age: "年齡",
    phone: "手機",
    lineId: "LINE ID",
    topics: "想諮詢的主題（可複選）",
    concern: "目前最困擾的問題",
    contactMethod: "希望聯繫方式",
    contactTime: "可聯繫時段",
    hasHistory: "是否已有體檢報告或過往療程經驗",
    submit: "送出預約",
    submitting: "送出中...",
    required: "此為必填項目",
    note: "本表單為預約諮詢申請，實際掛號與療程安排需由醫師於診間評估後決定。",
  },

  topicOptions: [
    { value: "reverse-aging", label: "逆齡評估" },
    { value: "male-aging", label: "男性懸崖式衰老" },
    { value: "acne", label: "青春痘 / 痘疤 / 膚況" },
    { value: "aesthetic", label: "醫美儀器 / 微整諮詢" },
    { value: "body", label: "體態管理" },
    { value: "senior", label: "熟齡 / 長青族慢老" },
    { value: "events", label: "活動講座 / 企業合作" },
    { value: "other", label: "其他" },
  ],

  genderOptions: [
    { value: "male", label: "男" },
    { value: "female", label: "女" },
    { value: "other", label: "其他" },
  ],

  contactMethodOptions: [
    { value: "phone", label: "電話" },
    { value: "line", label: "LINE" },
    { value: "both", label: "皆可" },
  ],

  historyOptions: [
    { value: "yes", label: "有" },
    { value: "no", label: "沒有" },
    { value: "unsure", label: "不確定" },
  ],

  contactTimeOptions: [
    { value: "morning", label: "上午（09:00–12:00）" },
    { value: "afternoon", label: "下午（13:00–17:00）" },
    { value: "evening", label: "晚上（17:00–20:00）" },
    { value: "any", label: "皆可" },
  ],

  infoCard: {
    title: "預約前提醒",
    items: [
      "填寫表單不代表完成掛號。",
      "專人將與您聯繫確認可預約時間。",
      "實際療程與醫療建議需由醫師看診後評估。",
      "若有急性不適或明顯症狀，請立即就醫，不建議僅透過線上表單等待回覆。",
    ],
  },

  lineSection: {
    label: "// QUICK CONTACT",
    title: "LINE 快速諮詢",
    lineId: "@404wdnql",
    cta: "加入 LINE 諮詢",
  },

  success: {
    title: "預約申請已送出",
    desc: "感謝您的預約申請！我們將在 1–2 個工作天內與您聯繫，確認可預約時段與相關細節。",
    ctaLine: "加入 LINE 諮詢",
    ctaHome: "返回首頁",
  },
};